import { Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { map, of } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { DetailPageComponent } from '../views/detail-page/detail-page.component';
import { InfoDialogComponent } from '../views/info-dialog/info-dialog.component';

@Injectable({
  providedIn: 'root',
})
export class ModalService {

  constructor(private dialog: MatDialog) { }

  confirmationDialog(dtitle: string, dmessage: string) {
    const dialogRef = this.dialog.open(InfoDialogComponent, {
      data: {
        title: dtitle,
        message: dmessage,
        yesNoButtons: true,
        okButton: false,
      },
      width: '40rem',
    });

    return dialogRef.afterClosed().pipe(
      map((result: any) => {
        if (result && result.ynSelection && result.ynSelection === 1) {
          return 'y';
        } else {
          return 'n';
        }
      })
    );
  }

  openTableDialog(data) {
    const dialogRef = this.dialog.open(DetailPageComponent, {
      data: {
        scheduler_data: data,
        yesNoButtons: false,
        okButton: true,
      },
      width: '50vw',
      height: '75vh',
      disableClose: true
    });

    return dialogRef.afterClosed().pipe(
      map((result: any) => {
        return 'y';
      })
    );
  }

}
